import PropTypes from 'prop-types'
import { iso8601PropType } from '../common/iso-8601-prop-type'
import { positionPropType } from '../common/position-prop-type'

/**
 * @typedef {Object} trackDataPropType
 * @property {number} course
 * @property {number} engineSpeed
 * @property {number} engineState
 * @property {number} gear
 * @property {number} gpsTime
 * @property {number} latitude
 * @property {number} longitude
 * @property {number} odometer
 * @property {number} receiveTime
 * @property {number} speed
 */
const trackDataPropType = PropTypes.shape({
    course: PropTypes.number,
    engineSpeed: PropTypes.number,
    engineState: PropTypes.bool,
    gear: PropTypes.number,
    gpsTime: iso8601PropType,
    odometer: PropTypes.number,
    position: positionPropType,
    receiveTime: iso8601PropType,
    speed: PropTypes.number
})

export { trackDataPropType }
